import React, { useState } from 'react'
import { useDispatch } from 'dva'
import { useHistory } from 'react-router-dom'
import { Button, Modal } from 'antd'
import { ProductErrorModal } from 'components'
import { useRequest } from '@sisyphe/hooks'
import * as api from 'services/store'

interface CartAnotherOrderProps {
  orderNo?: string
  children?: React.ReactElement
}
export default function CartAnotherOrder({
  orderNo,
  children,
}: CartAnotherOrderProps) {
  const dispatch = useDispatch()
  const history = useHistory()
  const [errorOpen, setErrorOpen] = useState(false)
  const [errorList, setErrorList] = useState<
    Array<SwaggerDTO.校验无法通过的商品信息>
  >([])

  /**购物车管理-再来一单 */
  const { run: repeatUsingPOST } = useRequest(
    async () => {
      const { data: errorData } = await api.repeatUsingGET(orderNo)
      // 错误信息
      if (errorData?.unPassData?.length) {
        setErrorList(errorData.unPassData)
        setErrorOpen(true)
        return false
      }
      dispatch({ type: 'cart/getShopCartNum' })
      history.push('/cart')
    },
    { manual: true }
  )

  return (
    <>
      {children ? (
        React.cloneElement(children, {
          onClick: () => {
            children?.props?.onClick?.()
            repeatUsingPOST()
          },
        })
      ) : (
        <Button type="link" onClick={repeatUsingPOST}>
          再来一单
        </Button>
      )}

      <Modal
        open={errorOpen}
        closable={false}
        width={350}
        onCancel={() => setErrorOpen(false)}
        maskClosable={false}
        footer={false}
        keyboard={false}
        destroyOnClose
      >
        <ProductErrorModal
          onOk={() => {
            history.push('/cart')
            dispatch({ type: 'cart/getShopCartNum' })
          }}
          data={errorList}
          tips="以下商品加购数超库存数量，将为你自动调整加购数量"
        />
      </Modal>
    </>
  )
}
